import { FC } from 'react';

import { useBanksQuery } from '@/api/getters';
import ComboBox from '@/components/ui/ComboBox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const BANK_NAME = 'bank';

interface Props {
  name?: string;
}

export const SelectBank: FC<Props> = ({ name = BANK_NAME }) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();
  const { data } = useBanksQuery();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: i18n.t('Uzupełnij to pole, aby przejść dalej'),
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>{i18n.t('Wskaż bank')}</FormLabel>
          <FormControl>
            <ComboBox
              field={field}
              placeholder={'Wybierz bank'}
              success={!fieldState.error && field.value}
              options={data ?? []}
              data-testid={`${name}-select`}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
